import { userRoles } from './roles';

/**
 * RW-3407 — Rêve's own system accounts ("Reve Workspace", which posts the weekly
 * leaderboard announcements; "Rêve Realtors") are users/{uid} docs with the agent
 * role, so they were listed as people: in the directory, its headcount, the
 * leaderboards, task pickers and rosters. The user doc's `isSystem: true` marks
 * one; every list of PEOPLE leaves it out. Lookups by id (a post's author name)
 * still find it. Set by scripts/rw3407-mark-system-accounts.js.
 */
export function isSystemAccount(user) {
  return !!user && user.isSystem === true;
}

/**
 * RW-3903: is this user doc a real agent, for a roster of agents (Credentials,
 * the Wave 1 picker)? Holds 'agent' in roles[] (userRoles — the singular
 * `role` is only roles[0], so reading it listed staff whose first role is
 * agent and missed agents whose first role is something else) and is not a
 * system account.
 */
export function isAgentPerson(user) {
  return !!user && !isSystemAccount(user) && userRoles(user).includes('agent');
}
